import { useState } from "react";
import s from "./ImageWithPlaceholder.module.scss";

const ImageWithPlaceholder = ({ src, alt, className }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className={`${s.wrapper} ${className || ""}`}>
            {/* show placeholder UNTIL image loads */}
            {!loaded && <div className={s.placeholder}></div>}

            <img
                src={src}
                alt={alt}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)} // prevent stuck loader
                className={`${s.image} ${loaded ? s.show : ""}`}
            />
        </div>
    );
};

export default ImageWithPlaceholder;